import { Injectable, Renderer2 } from '@angular/core';
import { BrowserStorage } from '../../models/browserStorage';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class TranslateWithKeysService {

    private nodes: { key: string, parentId: string, node: any }[] = []
    private nodesAssignment: { key: string, parentId: string, node: any }[] = []
    private _showKeys: boolean = false;
    SHOW_KEY = "show-keys";

    constructor(
      private api: ApiService
    ) { }


    changeKeys(showKeys: any) {
        BrowserStorage.set(this.SHOW_KEY, showKeys);
    }

    init(renderer: Renderer2) {
        if (this.getKeyValue()) {
            this.showLangKeys(renderer)
        } else {
            this.hiddenLangKeys(renderer)
        }
    }
    getKeyValue() {
        const value = BrowserStorage.get(this.SHOW_KEY);
        return value === "true";
    }

    showLangKeys(renderer: Renderer2) {

        for (const node of this.nodes) {
            renderer.setStyle(node.node, 'display', 'none');
        }
    }

    hiddenLangKeys(renderer: Renderer2) {

        for (const node of this.nodes) {
            renderer.setStyle(node.node, 'display', 'block');
        }
    }

    addNode(node: { key: string, parentId: string, node: any }) {
        this.nodes.push(node);
    }

    isKeyAlreadyExist(key: string, parentId: string) {
        return this.nodes.some(n => n.key == key && n.parentId == parentId)
    }
}
